import React from "react";
import Button from "carbon-react/lib/components/button";
import Dialog from "carbon-react/lib/components/dialog";
import { Column, Row } from "carbon-react/lib/components/row";
import Heading from "carbon-react/lib/components/heading";
import TextBox from "carbon-react/lib/__experimental__/components/textbox";
import TextArea from "carbon-react/lib/__experimental__/components/textarea";
import {
  getAuditOperationDisplayValue,
  getAuditOperationTypeDisplayValue,
} from "../../../constants/model";
import { useLocalization } from "../../../contexts/localization/Localization";

import "./AuditLogDialog.css";

const AuditLogDialogValue = ({ id, label, value }) => {
  return (
    <TextBox
      id={id}
      size="small"
      label={label ? label : " "}
      labelInline
      labelWidth={20}
      inputWidth={80}
      disabled
      value={value}
    />
  );
};

const AuditLogDialog = ({ open, onClose, auditLogEntry }) => {
  const { getLocalizedDateStringFromUtcValue } = useLocalization();

  const onCloseDialog = () => {
    onClose();
  };

  const buttonRow = (
    <Row className="audit-log-dialog-button-row">
      <Column columnAlign="right">
        <Button
          id="audit-log-entry-dialog-close-button"
          autoFocus
          buttonType="primary"
          onClick={onCloseDialog}
        >
          Close
        </Button>
      </Column>
    </Row>
  );

  const getOperationTypeDisplayValue = () => {
    return getAuditOperationTypeDisplayValue(auditLogEntry.operationType);
  };

  const getStatusDetail = () => {
    return (
      <>
        {auditLogEntry?.completed ? null : (
          <>
            <AuditLogDialogValue
              id="audit-log-entry-field-status-code"
              label="Code"
              value={auditLogEntry?.status?.code}
            />
            <AuditLogDialogValue
              id="audit-log-entry-field-http-status-code"
              label="Http Status Code"
              value={auditLogEntry?.status?.httpErrorStatusCode}
            />
            <div className="audit-log-error-response">
              <TextArea
                id="audit-log-entry-field-error-response"
                disabled
                label="Error Response"
                expandable={true}
                name="audit-log-status-error"
                value={auditLogEntry?.status?.errorResponse}
              />
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      {auditLogEntry ? (
        <Dialog
          open={open}
          onClose={onCloseDialog}
          onCancel={onCloseDialog}
          showCloseIcon={true}
        >
          <Heading title="Audit Log Entry" />
          <AuditLogDialogValue
            id="audit-log-entry-field-date"
            label="Date"
            value={getLocalizedDateStringFromUtcValue(auditLogEntry.createdUtc)}
          />
          <AuditLogDialogValue
            id="audit-log-entry-field-operation-type"
            label="Operation type"
            value={getOperationTypeDisplayValue()}
          />
          <AuditLogDialogValue
            id="audit-log-entry-field-operation"
            label="Operation"
            value={getAuditOperationDisplayValue(auditLogEntry.operation)}
          />
          <AuditLogDialogValue
            id="audit-log-entry-field-subject-email"
            label={`Subject (${getOperationTypeDisplayValue()})`}
            value={auditLogEntry.subjectEmail}
          />
          <AuditLogDialogValue
            id="audit-log-entry-field-subject-id"
            label="Subject ID"
            value={auditLogEntry.subjectId}
          />
          <AuditLogDialogValue
            id="audit-log-entry-field-subject-id"
            label="Completed"
            value={auditLogEntry.completed ? "True" : "False"}
          />
          {getStatusDetail()}
          <AuditLogDialogValue
            id="audit-log-entry-field-agent-email"
            label="Agent"
            value={auditLogEntry.agent?.email}
          />
          <AuditLogDialogValue
            id="audit-log-entry-field-agent-id"
            label="Agent ID"
            value={auditLogEntry.agent?.id}
          />
          <AuditLogDialogValue
            id="audit-log-entry-field-agent-role"
            label="Agent role"
            value={auditLogEntry.agent?.role}
          />
          <div className="audit-log-dialog-comment">
            <TextArea
              id="audit-log-entry-field-comment"
              name="auditLogComment"
              label="Comment"
              disabled
              labelWidth={20}
              value={auditLogEntry.comment}
            />
          </div>
          {buttonRow}
        </Dialog>
      ) : null}
    </>
  );
};

export default AuditLogDialog;
